
import { defineComponent, ref } from "vue";

import publicProfile from '@/modules/account/components/accountPublicProfileComponent.vue';
import personalInfo from '@/modules/account/components/accountPersonalInfoComponent.vue';
import password from '@/modules/account/components/accountPasswordComponent.vue';
import store from "@/store/index";

export default defineComponent({
  data: function () {
    return {
      resetPasswordSent: false,
      company: "",
      userData: store.getters["auth/user"] ?? "",
    };
  },
  methods: {
    resetPassword() {
      this.resetPasswordSent = true;
    },

    populateCompany() {
      if (this.userData !== "") {
        let user = store.getters["auth/user"];
        this.company = user.company;
      }
    },
  },

  name: "viewAccount",
  components: {
    publicProfile,
    personalInfo,
    password,
  },
  setup(){
    const tab = ref('profile');
    return {
      tab,
    }
  }
});
